/**
 * Tiny in-memory audit-trail helper for the bank-demo flows.
 * Pure utility: each call builds a new array (immutable) so React state
 * updates trigger renders cleanly.
 */
export const newTrail = () => [];

export const addEvent = (trail, event) => {
  const stamp = new Date();
  return [
    ...trail,
    {
      id: `${stamp.getTime()}-${Math.random().toString(36).slice(2, 7)}`,
      at: stamp.toISOString(),
      ...event, // { actor, action, resource, status, meta }
    },
  ];
};

export const fmtTime = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  } catch {
    return iso;
  }
};
